
/*global define */
define('jsx!components/survey-banner/main',['react', 'lib'], function(React, lib) {
    var PureRenderMixin = React.addons.PureRenderMixin;

	var SurveyBannerComponent = React.createClass({displayName: "SurveyBannerComponent",
        mixins: [PureRenderMixin],
        submit: function(accepted, link) {
        	return function(e) {
        		if (!link) {
        			e.preventDefault();
        		}
	            this.dismiss();

	            if (window.open && link) {
	            	window.open(link, '_blank');
	            }
	        }.bind(this);
        },
		dismiss: function() {
			lib.$html().removeClass('survey');

			setTimeout(function() {
				lib.$('#surveyBannerContainer').remove();
			}, 100);
		},
		renderMobile: function() {
			var link = this.props.data.link || '',
				disclaimerText = this.props.data.disclaimer || '',
				bodyText = this.props.data.body || '';

			return (
				React.createElement("div", {className: "survey-banner"}, 
					React.createElement("div", {className: "survey-banner__heading", onClick:  this.submit(false) }, 
						React.createElement("span", {className: "fa fa-times"})
					), 
					React.createElement("div", {className: "survey-banner__content", onClick:  this.submit(true, link) }, 
						React.createElement("div", {className: "survey-banner__content__body"}, 
							React.createElement("p", {className: "survey-banner__content__body__main"},  bodyText, " ",  disclaimerText )
						)
					)
				)
			);
		},
		renderDesktop: function() {
			var link = this.props.data.link || '',
				bodyText = this.props.data.body || '',
				disclaimerText = this.props.data.disclaimer || '',
				buttonTexts = this.props.data.buttonTexts;

			return (
				React.createElement("div", {className: "survey-banner survey-banner--desktop"}, 
					React.createElement("div", {className: "survey-banner__heading"}, 
						React.createElement("span", {className: "fa fa-question-circle-o"})
					), 
					React.createElement("div", {className: "survey-banner__content"}, 
						React.createElement("div", {className: "survey-banner__content__body"}, 
							React.createElement("p", {className: "survey-banner__content__body__main"},  bodyText ), 
							React.createElement("p", {className: "survey-banner__content__body__disclaimer"},  disclaimerText )
						), 
						React.createElement("div", {className: "survey-banner__content__button"}, 
							React.createElement("a", {onClick: this.submit(false), href: "#"}, 
								 buttonTexts.dismiss || 'Nei takk'
							)
						), 
						React.createElement("div", {className: "survey-banner__content__button survey-banner__content__button--primary"}, 
							React.createElement("a", {onClick: this.submit(true, link), href:  link, target: "_blank"}, 
								 buttonTexts.accept || 'Start nå'
							)
						)
					)
				)
			);
		},
		render: function() {
			if (lib.isMobile()) {
				return this.renderMobile();
			} else {
				return this.renderDesktop();
			}
		}
	});

	var SurveyManager = function(data) {
		if (window.localStorage) {
			return {
				hasShown: function() {
					return window.localStorage.getItem(data.surveyName) == 'true';
				},
				setShown: function() {
					window.localStorage.setItem(data.surveyName, true);
				}
			};
		} else {
			return {
				hasShown: function() {
					return document.cookie.indexOf(surveyName) > -1;
				},
				setShown: function() {
					var expires = new Date();
		        	expires.setDate(expires.getDate() + 14);
		        	document.cookie = data.surveyName + '=true; expires=' + expires + '; path=/';
				}
			};
		}
	};

	var SurveyBanner = function(data) {
		if (!data || !data.active) {
			return;
		}

		var targets = data.targets || [];

		if (targets.length > 0 && targets.indexOf(lib.getDevice()) === -1) {
			return;
		}

		var surveyManager = SurveyManager(data);

        if (surveyManager.hasShown() || document.referrer.indexOf('vg.no') > -1) {
            return;
        }

        lib.$body().append('<div id="surveyBannerContainer"></div>');
        var container = lib.$('#surveyBannerContainer');

		React.render(React.createElement(SurveyBannerComponent, {data:  data }), container.get(0));

        surveyManager.setShown();

		setTimeout(function() {
			lib.$html().addClass('survey');
		}, 10);
	};

	return SurveyBanner;
});

